import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  users: null,
};

export const users = createSlice({
  name: "users",
  initialState,
  reducers: {
    handleUsers: (state, action) => {
      state.users = action.payload;
    },
  },
});

export const usersState = (state) => state.users;

export const { handleUsers } = users.actions;

export default users.reducer;
